import { createEnhancedConversionsData } from "../utils/enhancedConversions";
import { createAddressObject } from "../utils/dataNormalizers";
import { getUserDataElement } from "../entry/global/domDataUtils";
import { hasStatisticsConsent } from "../utils/cookiebotConsent";

/**
 * Gets the user ID from the header element's data attribute.
 * @returns {string|null} The user ID or null if not found.
 */
export function getUserId() {
  const headerElement = getUserDataElement();
  if (!headerElement) {
    return null;
  }
  const userId = headerElement.dataset.userId;
  if (!userId || userId === "") {
    return null;
  }
  return userId.trim();
}

/**
 * Gets enhanced conversions data from the header element's data attributes.
 * @returns {object|null} The enhanced conversions object or null if no valid data or no consent.
 */
export function getEnhancedConversionsData() {
  const headerElement = getUserDataElement();
  if (!headerElement) {
    return null;
  }

  // Extract user data from data attributes
  const email = headerElement.dataset.userEmail || "";
  const phone = headerElement.dataset.userPhone || "";

  // Build address object using the convenience function
  const address = createAddressObject(
    headerElement.dataset.userFirstname || "",
    headerElement.dataset.userLastname || "",
    headerElement.dataset.userStreet || "",
    headerElement.dataset.userCity || "",
    headerElement.dataset.userRegion || "",
    headerElement.dataset.userPostalcode || "",
    headerElement.dataset.userCountry || "",
  );

  // Use the normalization module to create enhanced conversions data
  return createEnhancedConversionsData(email, phone, address);
}

/**
 * Adds user ID tracking to the dataLayer for analytics.
 * @returns {void}
 */
export function addUserIdTracking() {
  let userId = null;
  if (hasStatisticsConsent()) {
    userId = getUserId();
  }

  // Get enhanced conversions data (will check consent internally)
  const enhancedConversions = getEnhancedConversionsData();

  window.dataLayer = window.dataLayer || [];

  // Push both user_id and enhanced conversions in the same call
  const dataLayerPush = {
    user_id: userId,
  };

  if (enhancedConversions) {
    dataLayerPush["user_data"] = enhancedConversions;
  }

  dataLayer.push(dataLayerPush);
}
